import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M21 21H18V11H21V21ZM16 21H13V8H16V21ZM11 21H8V5H11V21ZM6 21H3V13H6V21Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "BarChart"
);
